import { Inject, Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Params, Router } from '@angular/router';
import { OktaAuth } from '@okta/okta-auth-js';
import { OKTA_AUTH } from '@okta/okta-angular';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  constructor(private injector: Injector, private router: Router, @Inject(OKTA_AUTH) private oktaAuthService: OktaAuth) {
  }

  intercept(request: HttpRequest<Params>, next: HttpHandler): Observable<HttpEvent<Params>> {

    if (request.headers.get('NO-INTERCEPT') !== 'true') {
      return this.processStandard(request, next);
    }

    return next.handle(request.clone({ headers: request.headers.delete('NO-INTERCEPT', 'true') }));
  }

  private processStandard(request: HttpRequest<Params>, next: HttpHandler): Observable<HttpEvent<Params>> {
    const idToken = this.oktaAuthService.getIdToken();
    if (idToken) {
      request = request.clone({
        setHeaders: { Authorization: `Bearer ${idToken}` },
      });
    }
    return next.handle(request);
  }
}
